(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl--error-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-error-message')) {
    customElements.define(
      'pl-error-message',
      class extends HTMLElement {
        #boundHandler = null
        #timeoutId = null

        connectedCallback() {
          const eventName = this.dataset.event
          if (!eventName) return

          this.#boundHandler = this.#handleEvent.bind(this)
          document.addEventListener(eventName, this.#boundHandler)
        }

        disconnectedCallback() {
          if (this.#boundHandler) {
            document.removeEventListener(this.dataset.event, this.#boundHandler)
          }
          if (this.#timeoutId) {
            clearTimeout(this.#timeoutId)
          }
        }

        #handleEvent(event) {
          const { message } = event.detail || {}
          if (!message) return

          // Check if we need to match a specific key
          const matchKey = this.dataset.matchKey
          const matchValue = this.dataset.matchValue

          if (matchKey && matchValue) {
            const eventValue = event.detail[matchKey]
            if (eventValue !== matchValue) return
          }

          // Show the message
          this.textContent = message
          this.setAttribute('data-visible', '')

          // Clear any existing timeout
          if (this.#timeoutId) {
            clearTimeout(this.#timeoutId)
          }

          // Auto-hide after timeout (0 = never)
          // Only auto-hide if not always visible
          const isAlwaysVisible = this.classList.contains('pl--error-message--always-visible')
          const timeout = parseInt(this.dataset.timeout) || 5000
          if (timeout > 0 && !isAlwaysVisible) {
            this.#timeoutId = setTimeout(() => {
              this.textContent = ''
              this.removeAttribute('data-visible')
            }, timeout)
          }
        }

        // Public method to manually clear
        clear() {
          this.textContent = ''
          this.removeAttribute('data-visible')
          if (this.#timeoutId) {
            clearTimeout(this.#timeoutId)
          }
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl--search-input"] && !Shopify.designMode) return;
  try {
    class PlSearchInput extends HTMLElement {
    #input = null
    #clearButton = null
    #debounceTimer = null
    #debounceMs = 300

    connectedCallback() {
      // Get debounce time from attribute
      const debounceAttr = this.getAttribute('data-debounce-ms')
      if (debounceAttr) {
        this.#debounceMs = parseInt(debounceAttr)
      }

      this.#input = this.querySelector('input[type="search"]')
      this.#clearButton = this.querySelector('[data-search-clear]')

      if (!this.#input || !this.#clearButton) return

      // Update clear button visibility based on input value
      this.#updateClearVisibility()

      // Listen for input changes
      this.#input.addEventListener('input', () => {
        this.#updateClearVisibility()
        this.#handleSearch()
      })

      // Clear button click
      this.#clearButton.addEventListener('click', () => {
        this.#clear()
      })

      // Enter key to search immediately
      this.#input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          this.#search(true) // Pass true to indicate this is from Enter key
        } else if (e.key === 'Escape') {
          this.#clear()
        }
      })
    }

    #updateClearVisibility() {
      if (this.#input.value.trim()) {
        this.#clearButton.setAttribute('data-visible', '')
      } else {
        this.#clearButton.removeAttribute('data-visible')
      }
    }

    #clear() {
      if (this.#input) {
        this.#input.value = ''
        this.#input.focus()
        this.#updateClearVisibility()
        // Dispatch clear event
        this.dispatchEvent(
          new CustomEvent('search:cleared', {
            bubbles: true,
          })
        )
      }
    }

    #handleSearch() {
      // Clear existing timer
      if (this.#debounceTimer) {
        clearTimeout(this.#debounceTimer)
      }

      // Set new timer
      this.#debounceTimer = setTimeout(() => {
        this.#search()
      }, this.#debounceMs)
    }

    #search(fromEnter = false) {
      const query = this.#input?.value.trim()

      // Dispatch search event with query
      this.dispatchEvent(
        new CustomEvent('search:query', {
          detail: { query, fromEnter },
          bubbles: true,
        })
      )
    }

    // Public method to focus the input (called when drawer opens)
    focusInput() {
      this.#input?.focus()
    }

    // Public method to set query
    setQuery(query) {
      if (this.#input) {
        this.#input.value = query
        this.#updateClearVisibility()
      }
    }
  }

  if (!customElements.get('pl-search-input')) {
    customElements.define('pl-search-input', PlSearchInput)
  }
  } catch(e) { console.error(e); }
})();

})();
